module.exports = __webpack_public_path__ + "static/media/3.5877b485.png";